// paymentChecker.ts

import { closeLoading, notifyError } from "src/assets/toastService";

const loadScript = (): Promise<boolean> => {
    return new Promise((resolve) => {
        const existing = document.querySelector(
            "script[src='https://checkout.razorpay.com/v1/checkout.js']"
        );

        if (existing) {
            resolve(true);
            return;
        }

        const script = document.createElement("script");

        script.src = "https://checkout.razorpay.com/v1/checkout.js";
        script.onload = () => resolve(true);
        script.onerror = () => resolve(false);

        document.body.appendChild(script);
    });
};

export const initRazorpayCheckout = async (): Promise<boolean> => {
    const loaded = await loadScript();

    if (!loaded) {
        closeLoading();
        notifyError("Razorpay failed");
        return false;
    }

    // continue with Razorpay checkout logic here
    return true;
};